import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

import { apiEndpointBaseUrl } from '@environments/environment'

import { isJwtTokenExpired } from '@utils/jwt-token'

const excludedAuthHeaderParts = [
  '/api/v1/StoreUser/Authenticate',
  '/api/v1/StoreUser/RefreshToken',
  '/api/v1/StoreUser/Register'
]

const shouldIncludesAuthToken = (url: string|undefined): boolean => {
  let result = true

  if (url && url.length)
    excludedAuthHeaderParts.forEach(part => {
      if (url.startsWith(part)) result = false
    })

  return result
}

const axiosInstance = axios.create({
  baseURL: apiEndpointBaseUrl,
  timeout: 30000
})

/* eslint no-debugger: "off" */
/* eslint no-console: "off" */
axiosInstance.interceptors.request.use(
  async (config: AxiosRequestConfig) => {
    if (shouldIncludesAuthToken(config.url)) {
      let jwtToken: string = localStorage.getItem('jwtToken') || ''

      if (isJwtTokenExpired(jwtToken)) {
        try {
          const refreshTokenResponse: any = await axiosInstance.post('/api/v1/StoreUser/RefreshToken', null, {
            headers: {
              refreshToken: localStorage.getItem('refreshToken')
            }
          })
          jwtToken = refreshTokenResponse.data.jwtToken
          localStorage.setItem('jwtToken', jwtToken)
          if (refreshTokenResponse.data.refreshToken) {
            localStorage.setItem('refreshToken', refreshTokenResponse.data.refreshToken)
          }
        } catch (e) {
          window.location.replace('/login')
        }
      }

      if (jwtToken) {
        config.headers.Authorization = `Bearer ${jwtToken}`
      }
    }

    return config
  },
  (error: any) => {
    Promise.reject(error)
  }
)

export default axiosInstance
